/**
 * @generated SignedSource<<de471f5ff0a4da4aae65ec94e49f080d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraBatchWindowPreference = "DEFAULT_BATCHING" | "FIFTEEN_MINUTES" | "FIVE_MINUTES" | "NO_BATCHING" | "ONCE_PER_DAY" | "ONE_DAY" | "ONE_HOUR" | "TEN_MINUTES" | "THIRTY_MINUTES" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceField$data = {
  readonly batchWindow: JiraBatchWindowPreference;
  readonly dailyBatchLocalTime: string | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceField";
};
export type batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceField$key = {
  readonly " $data"?: batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceField$data;
  readonly " $fragmentSpreads": FragmentRefs<"batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceField",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "dailyBatchLocalTime"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "batchWindow"
      },
      "action": "THROW",
      "path": "batchWindow"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    }
  ],
  "type": "JiraNotificationOptions"
};

(node as any).hash = "f8fbf1d8be26a73eb8fba69be6c7c617";

export default node;
